import { IconButton, Tooltip } from '@mui/material';
import { ErrorIcon, WarningIcon } from '../../../components/ui/icons';
import { Item } from '../../../domain/item';

/** Progress belongs in activity; cards only signal a decision or failed work. */
export function ItemCaptureAttention({ item }: { item: Item }) {
  const capture = item.localCapture;
  if (!capture?.attention) return null;
  const label = `${capture.attention === 'warning' ? 'Warning' : 'Error'} for ${item.keywords.trim() || 'Unnamed'}: open capture queue`;
  return (
    <Tooltip title="Capture needs attention">
      <IconButton
        size="small"
        aria-label={label}
        color={capture.attention}
        onClick={(event) => {
          event.stopPropagation();
          capture.openQueue();
        }}
        sx={{
          bgcolor: 'background.paper',
          // Match the theme's hover specificity to keep photos from showing through.
          '&:hover:not(.Mui-disabled)': { bgcolor: 'background.paper' },
        }}
      >
        {capture.attention === 'warning' ? (
          <WarningIcon fontSize="small" />
        ) : (
          <ErrorIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
}
